import React, { useEffect, useState } from "react"
import moment from "moment"
import PatientChip from "../../../PatientChip"

export default function EachWeekDay({
  eachDay,
  slot,
  appointments,
  onButtonClick,
  disablePopup,
  changeDay,
  outline,
  userRole,
  slotDuration,
  bedSlotDuration,
  show,
  reloadAppointments
}: any) {
  const [patients, updatePatients] = useState<Array<any>>()

  useEffect(() => {
    let currentSlot = moment(slot, "hh:mm a").format("HH:mm")

    const temp = appointments?.filter((eachApp: any) => {
      if (eachApp?.appointmentType === "IPD") {

        const sortedSlots = eachApp?.allottedBed?.slots?.sort(function (a: any, b: any) {
          return a < b ? -1 : 1
        })
        if (eachApp?.allottedBed && eachApp?.allottedBed?.slots) {
          eachApp["allottedBed"]["slots"] = sortedSlots
        }
        return (
          moment(eachApp?.scheduleDate).isSame(
            moment(eachDay?.totalDate),
            "days"
          ) &&
          eachApp?.allottedBed?.slots &&
          eachApp?.allottedBed?.slots[0] === currentSlot
        )
      } else {
        const sortedSlots = eachApp?.slots?.sort(function (a: any, b: any) {
          return a < b ? -1 : 1
        })
        eachApp["slots"] = sortedSlots
        return (
          moment(eachApp?.scheduleDate).isSame(
            moment(eachDay?.totalDate),
            "days"
          ) &&
          eachApp?.slots &&
          eachApp?.slots[0] === currentSlot
        )
      }
    })
    updatePatients(temp)
  }, [appointments])

  return (
    <div className="patient-list">
      <div className="divider-line col-md-12" />
      {patients && patients?.length > 1 ? (
        <div className="patient">
          <PatientChip
            patient={{
              patientName: `${patients?.length} more`,
              consultantColourCode: "#707070",
            }}
            disablePopup={true}
            onButtonClick={() =>
              changeDay(
                patients && patients[0] && patients[0]?.scheduleDate
                  ? patients[0]?.scheduleDate
                  : ""
              )
            }
            slotDuration={slotDuration}
            showModal={show}
            reloadAppointments={reloadAppointments}
          />
        </div>
      ) : (
        patients?.map((eachPatient: any) => (
          <div className="patient">
            <PatientChip
              patient={eachPatient}
              onButtonClick={onButtonClick}
              disablePopup={disablePopup}
              height={eachPatient?.allottedBed?.slots?.length || eachPatient.slots?.length}
              outline={outline}
              userRole={userRole}
              slotDuration={eachPatient?.appointmentType === "IPD" ? bedSlotDuration : slotDuration}
              showModal={show}
              reloadAppointments={reloadAppointments}
            />
          </div>
        ))
      )}
    </div>
  )
}
